module.exports = __webpack_public_path__ + "img/25.18e206f0.png";